import PropTypes from "prop-types";

CardBadge.propTypes = {
  badges: PropTypes.shape({
    isNew: PropTypes.bool,
    isUpdated: PropTypes.bool,
    isFeatured: PropTypes.bool,
  }),
};
export default function CardBadge({ badges }) {
  if (badges.isNew) {
    return (
      <div className="relative card-item new py-7 px-7 sj-light-blue h-[80px] z-50 rounded-tr-md">
        <span className="grid text-white justify-center font-extrabold relative z-20">NEW</span>
      </div>
    );
  } else if (badges.isUpdated) {
    return (
      <div className="card-item updated absolute top-0 right-0 py-7 px-7 sj-dark-yellow h-[80px] rounded-tr-md">
        <span className="grid justify-center font-extrabold relative z-20">UPDATED</span>
      </div>
    );
  } else if (badges.isFeatured) {
    return (
      <div className="card-item featured absolute top-0 right-0 py-7 px-7 sj-default-red h-[80px] rounded-tr-md">
        <span className="grid text-white justify-center font-extrabold relative z-20">
          FEATURED
        </span>
      </div>
    );
  }
}
